export const CATALOG_OWNERSHIP_ERROR_CODE = "CATALOG_MANAGED_BY_CENTRAL";

export const isCatalogOwnedByCentralError = (error) => {
  const code = error?.data?.code || error?.data?.title;
  const detail = `${error?.data?.detail || ""}`.toUpperCase();
  return (
    code === CATALOG_OWNERSHIP_ERROR_CODE ||
    detail.includes(CATALOG_OWNERSHIP_ERROR_CODE)
  );
};

export const getCatalogOwnershipMessage = (
  error,
  fallback = "Menu and upsell configuration is managed in Central Admin.",
) => {
  if (isCatalogOwnedByCentralError(error)) {
    return (
      error?.data?.detail ||
      "Catalog master data is managed in Central Admin. Only local availability can be updated on Edge."
    );
  }

  return error?.data?.detail || error?.data?.message || fallback;
};

